import { render, staticRenderFns } from "./RelatorioBoleado.vue?vue&type=template&id=f642dfea&scoped=true&"
import script from "./RelatorioBoleado.vue?vue&type=script&lang=js&"
export * from "./RelatorioBoleado.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioBoleado.vue?vue&type=style&index=0&id=f642dfea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f642dfea",
  null
  
)

export default component.exports